export default __webpack_public_path__ + "static/media/PPI-patio-014.5d5bf7bb.jpg";